import logo from './logo.svg';
import './App.css';
import { Button, Table } from 'react-bootstrap';
import { useEffect, useState } from 'react';
import { db, saveheartsCollection } from './firebase/firebase';
import { collection, getDocs } from 'firebase/firestore';
import CsvDownload from 'react-json-to-csv';
import { BsClipboardData } from "react-icons/bs";

function App() {
  const [docs, setDocs] = useState();
  const [topThree, setTopThree] = useState([])
  const [employees, setEmployees] = useState([{}])
  const [elnazerOrFriends, setElnazerOrFriends] = useState("Elnazer")
  function getTopThree(arr) {
    let tempArr = [];
    arr?.forEach((user) => {
      // console.log('compliance : ', user.complianceScore);
      // console.log('memes : ', user.memesScore);
      tempArr.push({ email: user.email, score: user.complianceScore ? user.complianceScore : 0 })
    })

    tempArr?.sort((a, b) => (a.score < b.score) ? 1 : ((b.score < a.score) ? -1 : 0))

    setEmployees(tempArr)
    setTopThree(tempArr.slice(0, 3))

    console.log(topThree);
  }
  async function getCollection(elnazerOrFriends) {
    let temp = [];

    const querySnapshot = await getDocs(collection(db, elnazerOrFriends));
    querySnapshot.forEach((doc) => {
      temp.push(doc.data())
    });
    setDocs([])
    setDocs(temp);
    console.log(temp);
  }
  useEffect(() => {
    getCollection("MCQ-elnazer")
  }, [])

  useEffect(() => {
    getTopThree(docs)
  }, [docs])
  const [CSV_DATA, setCSV_DATA] = useState([])
  useEffect(() => {
    let temp = []
    docs?.map((doc) => {
      let timeTaken = 0
      doc?.questions?.map((question) => {
        timeTaken = timeTaken + question.timeTaken
      })
      temp.push({
        email: doc.email, time: timeTaken, complianceScore: doc.endTime ? doc.complianceScore : `user haven't answered all questions`, memesScore: doc.endTime ? doc.memesScore : `user haven't answered all questions`, datePlayed: new Date(parseInt(doc.startTime)).toLocaleDateString() })
    })
      setCSV_DATA(temp)
    }, [docs, elnazerOrFriends])

    return (
      <div className="App">
        <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <Button disabled={elnazerOrFriends == 'Elnazer' ? true : false} style={{ borderColor: elnazerOrFriends == 'Elnazer' ? 'green' : 'gray', backgroundColor: elnazerOrFriends == 'Elnazer' && 'gray' }} onClick={() => {
            setElnazerOrFriends('Elnazer')
            getCollection("MCQ-elnazer")
          }}>Elnazer report </Button>
          <Button disabled={elnazerOrFriends == 'Friends' ? true : false} style={{ borderColor: elnazerOrFriends == 'Friends' ? 'green' : 'gray', backgroundColor: elnazerOrFriends == 'Friends' && 'gray' }} onClick={() => {
            setElnazerOrFriends('Friends')
            getCollection('MCQ-friends')
          }}>Friends report</Button>
          {/* <Button>Download CSV</Button> */}


        </div>
        <div style={{ borderRadius: '10px', borderStyle: 'solid', margin: 20, display: 'flex', justifyContent: 'flex-start', flexDirection: 'column' }}>
          <h3> Top 3 employees</h3>
          <div
            style={{ flexDirection: 'column', display: 'flex', justifyContent: 'space-between' }}
          >
            {topThree.map((employee) => {
              return (<div  >
                <p><b>Email : </b> {employee.email}</p>
                <p><b>Compliance score : </b>{employee.score}</p>

              </div>)
            })}
          </div>
        </div>
        <div className='d-flex m-3'>
          <Button>
            <CsvDownload className='text-white' title='Download as CSV' filename={`${elnazerOrFriends}-report.csv`} style={{ backgroundColor: 'transparent', borderStyle: 'none' }} data={CSV_DATA} >Download data as CSV</CsvDownload>
            <BsClipboardData />

          </Button>
        </div>
        <Table striped bordered hover>

          <thead>
            <tr>
              <th>#</th>
              <th style={{ width: '100%' }}>Interactions</th>
            </tr>
          </thead>
          {docs && docs.map((doc, index) => {

            return (

              <tbody style={{ borderWidth: 4, borderColor: 'rgba(0,0,0,0.7)' }}>
                <tr>
                  <td><b>{index + 1}</b></td>
                  {/* <td style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', fontWeight: 'bold' }}>{doc.email}</td> */}

                  {/* <td>
                  {doc.memesScore && (<tr><b>Memes score : {doc.memesScore}</b></tr>)}
                  {doc.complianceScore && (<tr><b>Compliance score : {doc.complianceScore}</b></tr>)}
                </td> */}
                  <td>
                    <td style={{ display: 'flex', justifyContent: 'flex-start', flexDirection: 'column', borderWidth: 1, borderColor: 'black', borderStyle: 'dotted' }}>
                      <tr >
                        <td >
                          <b>Email :</b>{doc.email}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Memes score : </b> {doc.memesScore}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Compliance score : </b>{doc.complianceScore}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Start time : </b>{new Date(parseInt(doc.startTime)).toLocaleDateString()} {new Date(parseInt(doc.startTime)).toTimeString()}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>End time : </b> {new Date(parseInt(doc.endTime)).toLocaleDateString()} {new Date(parseInt(doc.endTime)).toTimeString()}
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <b>Character : </b> {doc.character}
                        </td>
                      </tr>

                    </td>
                    <tr>

                      <Table striped>
                        <thead >
                          <tr  >
                            <td style={{ borderWidth: 2, width: '100%', backgroundColor: 'white' }}><b>Answers</b></td>
                            <td style={{ widows: '10%', backgroundColor: 'white' }}>Time taken in seconds</td>
                          </tr>
                        </thead>
                        <tbody >

                          {doc?.questions?.map((question) => {
                            return (
                              <>
                                <tr>
                                  <tr>
                                    <td style={{ width: '100%', backgroundColor: '#f1f1f1', margin: 2 }}><b>Question :</b> {question.questionTitle}</td>
                                  </tr>
                                  <tr>
                                    <td style={{ backgroundColor: 'rgba(0,0,0,0)', display: 'flex', flexGrow: 1, width: '100%', flex: 1, margin: 2 }}><b style={{ color: question.chosenAnswer.valid ? '#006633' : '#FF0000' }}>Answer :</b>{question.chosenAnswer == 'timeout' ? 'Time out' : question.chosenAnswer.option}</td>
                                    {question.chosenAnswer.input && <td style={{ backgroundColor: 'rgba(0,0,0,0)', display: 'flex', flexGrow: 1, width: '100%', flex: 1, margin: 2 }}><b >Why :</b>{question.chosenAnswer.why}</td>}
                                  </tr>
                                  <td>{question.timeTaken} </td>
                                </tr>

                              </>
                            )
                          })}
                        </tbody>
                      </Table>
                    </tr></td>
                </tr>

              </tbody>

            )
          })}
        </Table >
      </div >
    );
  }

export default App;
